module.exports = __webpack_public_path__ + "img/tacna-logo.e36e00b4.png";